import { render, staticRenderFns } from "./ConstructionNew.vue?vue&type=template&id=872c84d4&scoped=true&lang=pug&"
import script from "./ConstructionNew.vue?vue&type=script&lang=ts&"
export * from "./ConstructionNew.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionNew.vue?vue&type=style&index=0&id=872c84d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c84d4",
  null
  
)

export default component.exports